
export default function () {
    return (
        <div style={{ color: "#fff" }}>
            <h1>404</h1>
            <h3>お探しのページは見つかりませんでした。</h3>
        </div>
    );
}